export const SITES = [
    {
        id: 0,
        name: "Coffee Affection 1",
        image: "/assets/images/coffee-package.jpeg",
        featured: false,
        description: "Ethiopian, house blended organic coffee.We’re committed to quality, service, integrity, approachability, and sustainability. ",
    },
    
    
    {
        id: 1,
        name: "Coffee Affection 2",
        image:"/assets/images/affection1.jpeg",
        featured: true,
        description: "This sweet and organic Ethiopian coffee is Fair Trade and USDA Organic Certified. With hints of bright citruses like sweet tangerine and lime, the acidity level is powerful and bright, while the cup finishes with a dry, lemon tea finish.",
    }
]